var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3217_23476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99999 0H15.7447L22.5 6.72902V22.5C22.5 23.3287 21.828 24 21 24H2.99999C2.17196 24 1.5 23.3287 1.5 22.5V1.49999C1.5 0.671265 2.17204 0 2.99999 0Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4782 6.75013H17.25C16.422 6.75013 15.75 6.07817 15.75 5.25015V0.0151367L22.4782 6.75013Z",
    fill: "#B53629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8736 11.372C17.1248 11.372 17.2478 11.153 17.2478 10.9408C17.2478 10.721 17.1196 10.5088 16.8736 10.5088H15.4426C15.1628 10.5088 15.0068 10.7405 15.0068 10.9963V14.513C15.0068 14.8265 15.1853 15.0005 15.4268 15.0005C15.6668 15.0005 15.8461 14.8265 15.8461 14.513V13.5478H16.7116C16.9801 13.5478 17.1144 13.328 17.1144 13.1098C17.1144 12.8961 16.9801 12.6838 16.7116 12.6838H15.8461V11.372H16.8736ZM12.0368 10.5088H10.9898C10.7055 10.5088 10.5038 10.7038 10.5038 10.9933V14.516C10.5038 14.8753 10.794 14.9878 11.0017 14.9878H12.1005C13.401 14.9878 14.2597 14.1321 14.2597 12.8113C14.259 11.4148 13.4506 10.5088 12.0368 10.5088ZM12.0871 14.1193H11.4488V11.3773H12.0241C12.8949 11.3773 13.2736 11.9616 13.2736 12.7678C13.2736 13.5223 12.9015 14.1193 12.0871 14.1193ZM8.25158 10.5088H7.21434C6.92108 10.5088 6.75757 10.7023 6.75757 10.9963V14.513C6.75757 14.8265 6.94506 15.0005 7.19703 15.0005C7.44901 15.0005 7.6365 14.8265 7.6365 14.513V13.4863H8.28673C9.08922 13.4863 9.75149 12.9177 9.75149 12.0035C9.75156 11.1088 9.11258 10.5088 8.25158 10.5088ZM8.23435 12.6613H7.63658V11.3346H8.23435C8.60335 11.3346 8.8381 11.6225 8.8381 11.9983C8.83732 12.3734 8.60335 12.6613 8.23435 12.6613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3217_23476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.561b4b5b0eb42ecfc7c45e146467c5a0.svg";
export { ForwardRef as ReactComponent };